/** Demo v0.2.1 — comunicaciones, emails simulados, plantillas, historial, audiencias, notificaciones y tareas (solo frontend). */

export const DEMO_FEATURED_COMMS = [
  {
    id: 'fc1',
    title: 'Actualización de políticas de trabajo remoto',
    summary: 'Lineamientos 2026 y registro de acuerdos con managers.',
    category: 'rrhh',
    audience: 'managers',
    author: 'Ana Martínez',
    date: '2026-02-01',
  },
  {
    id: 'fc2',
    title: 'Beneficios: nuevo convenio de salud',
    summary: 'Cobertura ampliada y pasos para adhesión voluntaria.',
    category: 'benefits',
    audience: 'all',
    author: 'People Ops',
    date: '2026-01-28',
  },
  {
    id: 'fc3',
    title: 'Recordatorio compliance — declaraciones',
    summary: 'Ventana de carga hasta el 15/02. Soporte RRHH disponible.',
    category: 'compliance',
    audience: 'employees',
    author: 'RRHH',
    date: '2026-01-22',
  },
];

export const DEMO_EMAILS = [
  {
    id: 'em1',
    toLabel: 'Todos · Tecnología',
    subject: 'Bienvenida al equipo — Martín Gómez',
    type: 'welcome',
    templateKey: 'tpl_welcome',
    status: 'prepared',
    priority: 'normal',
    updatedAt: '2026-02-08',
  },
  {
    id: 'em2',
    toLabel: 'Sofía Herrera',
    subject: 'Documentación pendiente de firma',
    type: 'docs_pending',
    templateKey: 'tpl_docs_pending',
    status: 'queued',
    priority: 'high',
    updatedAt: '2026-02-07',
  },
  {
    id: 'em3',
    toLabel: 'Diego Rojas',
    subject: 'Tu licencia fue aprobada',
    type: 'leave_approved',
    templateKey: 'tpl_leave_ok',
    status: 'sent_sim',
    priority: 'normal',
    updatedAt: '2026-02-05',
  },
  {
    id: 'em4',
    toLabel: 'Lucía Fernández',
    subject: 'Actualización sobre tu rendición',
    type: 'expense_rejected',
    templateKey: 'tpl_leave_rej',
    status: 'failed_sim',
    priority: 'high',
    updatedAt: '2026-02-04',
  },
  {
    id: 'em5',
    toLabel: 'Martín Gómez',
    subject: 'Evaluación de desempeño pendiente',
    type: 'eval_pending',
    templateKey: 'tpl_eval_pending',
    status: 'prepared',
    priority: 'high',
    updatedAt: '2026-02-03',
  },
  {
    id: 'em6',
    toLabel: 'Diego Rojas',
    subject: 'Capacitación obligatoria asignada',
    type: 'training_assigned',
    templateKey: 'tpl_training',
    status: 'queued',
    priority: 'normal',
    updatedAt: '2026-02-02',
  },
  {
    id: 'em7',
    toLabel: 'Todos · Colaboradores',
    subject: 'Encuesta de clima Q1 — tu opinión importa',
    type: 'climate_survey',
    templateKey: 'tpl_climate_survey',
    status: 'prepared',
    priority: 'normal',
    updatedAt: '2026-02-01',
  },
];

/** 10 plantillas demo — claves alineadas con i18n `communications.template.*` */
export const DEMO_TEMPLATES = [
  { id: 't1', key: 'tpl_welcome', category: 'rrhh', channel: 'email', status: 'active', updatedAt: '2026-02-01', vars: '{{employee_name}}, {{manager_name}}, {{company_name}}' },
  { id: 't2', key: 'tpl_docs_pending', category: 'compliance', channel: 'email', status: 'active', updatedAt: '2026-01-30', vars: '{{employee_name}}, {{document_name}}, {{due_date}}' },
  { id: 't3', key: 'tpl_doc_expired', category: 'compliance', channel: 'email', status: 'active', updatedAt: '2026-01-28', vars: '{{document_name}}, {{due_date}}, {{employee_name}}' },
  { id: 't4', key: 'tpl_leave_ok', category: 'rrhh', channel: 'email', status: 'active', updatedAt: '2026-01-25', vars: '{{employee_name}}, {{leave_dates}}' },
  { id: 't5', key: 'tpl_leave_rej', category: 'rrhh', channel: 'email', status: 'active', updatedAt: '2026-01-25', vars: '{{employee_name}}, {{leave_dates}}' },
  { id: 't6', key: 'tpl_exp_ok', category: 'rrhh', channel: 'email', status: 'active', updatedAt: '2026-01-20', vars: '{{employee_name}}, {{company_name}}' },
  { id: 't7', key: 'tpl_eval_pending', category: 'rrhh', channel: 'portal', status: 'active', updatedAt: '2026-02-02', vars: '{{employee_name}}, {{manager_name}}' },
  { id: 't8', key: 'tpl_training', category: 'rrhh', channel: 'portal', status: 'active', updatedAt: '2026-01-29', vars: '{{employee_name}}, {{course_name}}' },
  { id: 't9', key: 'tpl_climate_survey', category: 'rrhh', channel: 'internal', status: 'active', updatedAt: '2026-01-15', vars: '{{survey_link}}, {{company_name}}' },
  { id: 't10', key: 'tpl_urgent_comms', category: 'urgent', channel: 'email', status: 'active', updatedAt: '2026-02-06', vars: '{{employee_name}}, {{company_name}}' },
];

export const DEMO_MSG_HISTORY = [
  { id: 'h1', date: '2026-02-08', typeKey: 'histTypeEmail', to: 'Área Comercial', channelKey: 'channelEmail', subject: 'Pulso de clima — recordatorio', statusKey: 'histSentSim', actor: 'Ana Martínez', resultKey: 'histResultOk' },
  { id: 'h2', date: '2026-02-07', typeKey: 'histTypePortal', to: 'Martín Gómez', channelKey: 'channelPortal', subject: 'Capacitación obligatoria asignada', statusKey: 'histReadSim', actor: 'RRHH', resultKey: 'histResultRead' },
  { id: 'h3', date: '2026-02-06', typeKey: 'histTypeEmail', to: 'Todos', channelKey: 'channelEmail', subject: 'Comunicado general — enero', statusKey: 'histPrepared', actor: 'People Ops', resultKey: 'histResultPending' },
  { id: 'h4', date: '2026-02-05', typeKey: 'histTypeEmail', to: 'Sofía Herrera', channelKey: 'channelEmail', subject: 'Bienvenida', statusKey: 'histQueued', actor: 'RRHH', resultKey: 'histResultQueue' },
  { id: 'h5', date: '2026-02-04', typeKey: 'histTypeEmail', to: 'Lucía Fernández', channelKey: 'channelEmail', subject: 'Gasto — observaciones', statusKey: 'histFailedSim', actor: 'Finance Ops', resultKey: 'histResultFail' },
];

export const DEMO_AUDIENCES = [
  { id: 'a1', key: 'aud_all', count: 248, useKey: 'audUseAll', channelsKey: 'audChAll', statusKey: 'audActive' },
  { id: 'a2', key: 'aud_managers', count: 42, useKey: 'audUseMgr', channelsKey: 'audChMgr', statusKey: 'audActive' },
  { id: 'a3', key: 'aud_new_hires', count: 6, useKey: 'audUseNew', channelsKey: 'audChNew', statusKey: 'audActive' },
  { id: 'a4', key: 'aud_docs_pending', count: 18, useKey: 'audUseDocs', channelsKey: 'audChDocs', statusKey: 'audActive' },
  { id: 'a5', key: 'aud_leaves_upcoming', count: 11, useKey: 'audUseLeave', channelsKey: 'audChLeave', statusKey: 'audActive' },
  { id: 'a6', key: 'aud_eval_pending', count: 9, useKey: 'audUseEval', channelsKey: 'audChEval', statusKey: 'audActive' },
  { id: 'a7', key: 'aud_area_tech', count: 54, useKey: 'audUseTech', channelsKey: 'audChArea', statusKey: 'audActive' },
  { id: 'a8', key: 'aud_area_sales', count: 36, useKey: 'audUseSales', channelsKey: 'audChArea', statusKey: 'audActive' },
  { id: 'a9', key: 'aud_area_admin', count: 28, useKey: 'audUseAdmin', channelsKey: 'audChArea', statusKey: 'audActive' },
  { id: 'a10', key: 'aud_area_people', count: 12, useKey: 'audUsePeople', channelsKey: 'audChPeople', statusKey: 'audActive' },
];

export const DEMO_NOTIFICATIONS = [
  { id: 'n1', titleKey: 'notifItemDocExpired', priority: 'high', status: 'pending', due: '2026-02-10', moduleKey: 'modLegajo' },
  { id: 'n2', titleKey: 'notifItemLeavePending', priority: 'medium', status: 'in_progress', due: '2026-02-09', moduleKey: 'modLeaves' },
  { id: 'n3', titleKey: 'notifItemExpensePending', priority: 'medium', status: 'pending', due: '2026-02-11', moduleKey: 'modExpenses' },
  { id: 'n4', titleKey: 'notifItemEvalPending', priority: 'high', status: 'pending', due: '2026-02-08', moduleKey: 'modEmployees' },
  { id: 'n5', titleKey: 'notifItemTrainingOverdue', priority: 'high', status: 'overdue', due: '2026-02-01', moduleKey: 'modEmployees' },
  { id: 'n6', titleKey: 'notifItemSurveyLow', priority: 'low', status: 'pending', due: '2026-02-15', moduleKey: 'modEmployees' },
  { id: 'n7', titleKey: 'notifItemOnboard', priority: 'medium', status: 'in_progress', due: '2026-02-12', moduleKey: 'modEmployees' },
  { id: 'n8', titleKey: 'notifItemOffboard', priority: 'high', status: 'pending', due: '2026-02-07', moduleKey: 'modEmployees' },
  {
    id: 'n9',
    titleKey: 'notifItemFlowPrep',
    priority: 'medium',
    status: 'pending',
    due: '2026-02-21',
    moduleKey: 'modSettings',
    kind: 'integration',
  },
];

export const DEMO_RRHH_TASKS = [
  { id: 'tk1', titleKey: 'taskDemo1', owner: 'Ana Martínez', moduleKey: 'modLegajo', due: '2026-02-09', priority: 'high', status: 'pending' },
  { id: 'tk2', titleKey: 'taskDemo2', owner: 'Lucía Fernández', moduleKey: 'modLeaves', due: '2026-02-08', priority: 'medium', status: 'in_progress' },
  { id: 'tk3', titleKey: 'taskDemo3', owner: 'People Ops', moduleKey: 'modEmployees', due: '2026-02-14', priority: 'high', status: 'pending' },
  { id: 'tk4', titleKey: 'taskDemo4', owner: 'Finance Ops', moduleKey: 'modExpenses', due: '2026-02-10', priority: 'medium', status: 'pending' },
  { id: 'tk5', titleKey: 'taskDemo5', owner: 'RRHH', moduleKey: 'modEmployees', due: '2026-02-06', priority: 'low', status: 'completed' },
  { id: 'tk6', titleKey: 'taskDemo6', owner: 'Mauro Lucena', moduleKey: 'modEmployees', due: '2026-02-20', priority: 'high', status: 'pending' },
  { id: 'tk7', titleKey: 'taskDemo7', owner: 'Ana Martínez', moduleKey: 'modEmployees', due: '2026-02-13', priority: 'medium', status: 'pending' },
  { id: 'tk8', titleKey: 'taskPerm1', owner: 'People Ops', moduleKey: 'modSettings', due: '2026-02-18', priority: 'high', status: 'pending' },
  { id: 'tk9', titleKey: 'taskPerm2', owner: 'RRHH', moduleKey: 'modSettings', due: '2026-02-19', priority: 'medium', status: 'pending' },
  { id: 'tk10', titleKey: 'taskPerm3', owner: 'RRHH', moduleKey: 'modEmployees', due: '2026-02-17', priority: 'high', status: 'in_progress' },
  { id: 'tk11', titleKey: 'taskPerm4', owner: 'Finance Ops', moduleKey: 'modExpenses', due: '2026-02-16', priority: 'medium', status: 'pending' },
  { id: 'tk12', titleKey: 'taskPerm5', owner: 'CTO', moduleKey: 'modSettings', due: '2026-02-22', priority: 'low', status: 'pending' },
];
